// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"640":"b2fa23a809053c6305c5","5771":"a4e2a98efcfb7393c5bd","5810":"44e839656fd178ba3292","7432":"bf576075b1d8131aa273"}[chunkId] + "";
};